// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ProductImage_imageContainer__xd6fc","image":"ProductImage_image__PsWgH","imagePicture":"ProductImage_imagePicture__MdpzK"};